import React, { useEffect, useState } from 'react'

function useWindow ( debounceMs = 1000 ) {
    const [size, setSize] = useState( {
        width: window.innerWidth,
        height: window.innerHeight,
    } )

    useEffect( () => {
        let timeout

        const onResize = () => {
            clearTimeout( timeout )
            timeout = window.setTimeout( () => {
                setSize( { width: window.innerWidth, height: window.innerHeight } )
            }, debounceMs )
        }

        window.addEventListener( "resize", onResize )
        return () => {
            clearTimeout( timeout )
            window.removeEventListener( "resize", onResize )
        }
    }, [debounceMs] )

    return size
}

export default useWindow